var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-row',[_c('b-colxx',{attrs:{"xxs":"12"}},[_c('piaf-breadcrumb',{attrs:{"heading":_vm.$t('menu.booking-status')}}),_vm._v(" "),_c('div',{staticClass:"separator mb-5"})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }